const COMPARISON_EPSILON = 0.0001

export const EXACT_PRODUCTION_WIDTH_IN = 22
export const LEGACY_HARD_WIDTH_LIMIT_IN = 22.25

export function usesExactProductionWidth(nominalWidth) {
  const width = Number(nominalWidth)
  return Number.isFinite(width) &&
    Math.abs(width - EXACT_PRODUCTION_WIDTH_IN) <= COMPARISON_EPSILON
}

export function sheetWidthPolicy(nominalWidth) {
  const width = Number(nominalWidth)
  if (!usesExactProductionWidth(width)) {
    return {
      nominalWidthIn: width,
      layoutWidthIn: width,
      hardWidthLimitIn: width,
      horizontalSafetyMarginIn: 0.125,
    }
  }

  return {
    nominalWidthIn: EXACT_PRODUCTION_WIDTH_IN,
    layoutWidthIn: EXACT_PRODUCTION_WIDTH_IN,
    // Kept solely so paid/ready layouts saved before the exact-width fix can regenerate.
    hardWidthLimitIn: LEGACY_HARD_WIDTH_LIMIT_IN,
    // A nominal 22-inch sheet must generate a 22-inch print file. Horizontal
    // edge allowance belongs to the physical media, not the exported canvas.
    horizontalSafetyMarginIn: 0,
  }
}
